"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.website = void 0;
const feedback_1 = require("./feedback");
exports.website = {
    feedback: feedback_1.feedback,
};
